import React from 'react'
import Button from './Button'

export default function SignOutButton({ className = '' }) {
  const handleSubmit = (e) => {
    e.target.authenticity_token.value =
      document.querySelector('meta[name="csrf-token"]')?.content || ''
  }

  return (
    <form action="/logout" method="post" onSubmit={handleSubmit} style={{ display: 'contents' }}>
      <input type="hidden" name="_method" value="delete" />
      <input type="hidden" name="authenticity_token" value="" />
      <Button
        type="submit"
        link
        variant="danger"
        className={`w-full text-left justify-start ${className}`}
      >
        Sign Out
      </Button>
    </form>
  )
}
